interface IconProps {
  className?: string;
}
const ChevronDownSolidIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 11 5"
      className={className ? className : "w-4 h-4"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M10.054 0c.525 0 .788.568.417.9L6.06 4.846a.64.64 0 0 1-.833 0L.818.9C.448.568.71 0 1.235 0z"
      ></path>
    </svg>
  );
};

export default ChevronDownSolidIcon;
